import { api } from './api.config'
import request from '@/utils/request'
export const reqConfig = {
  ding: {
    loginByCode (data) {
      return request({
        url: api.ding.loginByCode,
        method: 'get',
        data
      })
    },
    getDingConfig (data) {
      return request({
        url: api.ding.getDingConfig,
        method: 'get',
        data
      })
    },
    getDingToken (data) {
      return request({
        url: api.ding.getDingToken,
        method: 'get',
        data
      })
    },
    getInviteParam (data) {
      return request({
        url: api.ding.getInviteParam,
        method: 'get',
        data
      })
    },
    getJurisdiction (data) {
      return request({
        url: api.ding.getJurisdiction,
        method: 'get',
        data
      })
    }
  },
  workWechat: {
    getConfig (data) {
      return request({
        url: api.workWechat.getConfig,
        method: 'get',
        data
      })
    },
    getAgentConfig (data) {
      return request({
        url: api.workWechat.getAgentConfig,
        method: 'get',
        data
      })
    }
  }
}
